module.exports = __webpack_public_path__ + "img/dress_4.27f8aafb.png";